(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8957],{

/***/ 23580:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/faq",
      function () {
        return __webpack_require__(39331);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 80635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ BaseAccordion; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32317);
/* harmony import */ var _styles_typography__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67246);
/* harmony import */ var baseui_accordion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37244);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43281);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_use_overrides__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58817);
/* harmony import */ var _icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32079);











var BaseAccordion = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var children = _param.children, overrides = _param.overrides, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children",
        "overrides"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        accordion: true,
        overrides: (0,_hooks_use_overrides__WEBPACK_IMPORTED_MODULE_6__/* .useOverrides */ .Q)({
            ToggleIcon: {
                component: function(param) {
                    var $expanded = param.$expanded;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon__WEBPACK_IMPORTED_MODULE_7__/* .Icon */ .J, {
                        size: 16,
                        color: _styles_colors__WEBPACK_IMPORTED_MODULE_8__/* .colors.black */ .O.black,
                        type: $expanded ? "ChevronUp" : "ChevronDown"
                    });
                }
            },
            Header: {
                style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (0,polished__WEBPACK_IMPORTED_MODULE_9__/* .padding */ .o3)("24px", "4px"), _styles_typography__WEBPACK_IMPORTED_MODULE_10__/* .typography.LabelM */ .c.LabelM), {
                    fontWeight: 400,
                    userSelect: "none"
                })
            },
            Content: {
                style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, _styles_typography__WEBPACK_IMPORTED_MODULE_10__/* .typography.LabelS */ .c.LabelS)
            }
        }, overrides)
    }, props), {
        children: children
    }));
});


/***/ }),

/***/ 1650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ BasePanel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var baseui_accordion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80027);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);






var BasePanel = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        ref: ref,
        children: children
    }));
});


/***/ }),

/***/ 11485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ BaseButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/baseui/esm/button/button.js + 3 modules
var button_button = __webpack_require__(53674);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 3 modules
var polished_esm = __webpack_require__(43281);
// EXTERNAL MODULE: ./components/hooks/use-overrides.ts
var use_overrides = __webpack_require__(58817);
// EXTERNAL MODULE: ./styles/colors.ts
var colors = __webpack_require__(32317);
;// CONCATENATED MODULE: ./components/base-button/use-button-style.tsx



var useButtonStyle = function($type, $size) {
    var backgroundColor = {
        primary: colors/* colors.blue400 */.O.blue400,
        secondary: colors/* colors.blue50 */.O.blue50,
        tertiary: colors/* colors.white */.O.white,
        danger: colors/* colors.red400 */.O.red400,
        warning: colors/* colors.red50 */.O.red50,
        text: colors/* colors.white */.O.white
    }[$type];
    var hoverBackgroundColor = {
        primary: colors/* colors.blue500 */.O.blue500,
        secondary: colors/* colors.blue100 */.O.blue100,
        tertiary: colors/* colors.blue50 */.O.blue50,
        danger: colors/* colors.red500 */.O.red500,
        warning: colors/* colors.red100 */.O.red100,
        text: colors/* colors.blue50 */.O.blue50
    }[$type];
    var color = {
        primary: colors/* colors.white */.O.white,
        secondary: colors/* colors.blue400 */.O.blue400,
        tertiary: colors/* colors.blue400 */.O.blue400,
        danger: colors/* colors.white */.O.white,
        warning: colors/* colors.red400 */.O.red400,
        text: colors/* colors.gray700 */.O.gray700
    }[$type];
    var hoverColor = {
        primary: colors/* colors.white */.O.white,
        secondary: colors/* colors.blue400 */.O.blue400,
        tertiary: colors/* colors.blue400 */.O.blue400,
        danger: colors/* colors.white */.O.white,
        warning: colors/* colors.red400 */.O.red400,
        text: colors/* colors.gray700 */.O.gray700
    }[$type];
    var disabledBackgroundColor = {
        primary: colors/* colors.gray300 */.O.gray300,
        secondary: colors/* colors.gray100 */.O.gray100,
        tertiary: colors/* colors.white */.O.white,
        danger: colors/* colors.gray300 */.O.gray300,
        warning: colors/* colors.gray100 */.O.gray100,
        text: colors/* colors.gray100 */.O.gray100
    }[$type];
    var disabledColor = {
        primary: colors/* colors.white */.O.white,
        secondary: colors/* colors.gray300 */.O.gray300,
        tertiary: colors/* colors.gray300 */.O.gray300,
        danger: colors/* colors.white */.O.white,
        warning: colors/* colors.gray300 */.O.gray300,
        text: colors/* colors.gray300 */.O.gray300
    }[$type];
    var border = {
        primary: "transparent",
        secondary: "transparent",
        tertiary: colors/* colors.blue100 */.O.blue100,
        danger: "transparent",
        warning: "transparent",
        text: "transparent"
    }[$type];
    var hoverBorder = {
        primary: "transparent",
        secondary: "transparent",
        tertiary: colors/* colors.blue50 */.O.blue50,
        danger: "transparent",
        warning: "transparent",
        text: colors/* colors.gray50 */.O.gray50
    }[$type];
    var size = {
        l: (0,_object_spread/* default */.Z)({
            fontSize: "18px",
            lineHeight: "22px"
        }, (0,polished_esm/* padding */.o3)("11px", "19px")),
        m: (0,_object_spread/* default */.Z)({
            fontSize: "16px",
            lineHeight: "20px"
        }, (0,polished_esm/* padding */.o3)("7px", "19px")),
        s: (0,_object_spread/* default */.Z)({
            fontSize: "14px",
            lineHeight: "18px"
        }, (0,polished_esm/* padding */.o3)("4px", "19px"))
    }[$size];
    return {
        backgroundColor: backgroundColor,
        hoverBackgroundColor: hoverBackgroundColor,
        color: color,
        hoverColor: hoverColor,
        disabledBackgroundColor: disabledBackgroundColor,
        disabledColor: disabledColor,
        border: border,
        hoverBorder: hoverBorder,
        size: size
    };
};

// EXTERNAL MODULE: ./components/icon/icon.tsx + 175 modules
var icon = __webpack_require__(32079);
// EXTERNAL MODULE: ./components/hooks/use-space.ts
var use_space = __webpack_require__(16333);
;// CONCATENATED MODULE: ./components/base-button/base-button.tsx











var BaseButton = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var children = _param.children, overrides = _param.overrides, fluid = _param.fluid, leading = _param.leading, trailing = _param.trailing, _$size = _param.$size, $size = _$size === void 0 ? "l" : _$size, _$type = _param.$type, $type = _$type === void 0 ? "primary" : _$type, spaceTop = _param.spaceTop, spaceBottom = _param.spaceBottom, width = _param.width, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "overrides",
        "fluid",
        "leading",
        "trailing",
        "$size",
        "$type",
        "spaceTop",
        "spaceBottom",
        "width"
    ]);
    var _$ref = useButtonStyle($type, $size), backgroundColor = _$ref.backgroundColor, hoverBackgroundColor = _$ref.hoverBackgroundColor, color = _$ref.color, hoverColor = _$ref.hoverColor, disabledBackgroundColor = _$ref.disabledBackgroundColor, disabledColor = _$ref.disabledColor, border = _$ref.border, hoverBorder = _$ref.hoverBorder, size = _$ref.size;
    var _$ref1 = (0,use_space/* useSpace */.$)({
        spaceTop: spaceTop,
        spaceBottom: spaceBottom
    }), marginTop = _$ref1.marginTop, marginBottom = _$ref1.marginBottom;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        overrides: (0,use_overrides/* useOverrides */.Q)({
            BaseButton: {
                style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, size, marginTop, marginBottom), {
                    color: color,
                    backgroundColor: backgroundColor,
                    width: width ? "".concat(width, "px") : fluid ? "100%" : "auto",
                    boxSizing: "border-box",
                    fontWeight: 500,
                    wordBreak: "keep-all",
                    whiteSpace: "pre",
                    position: "relative"
                }), (0,polished_esm/* borderRadius */.E0)("left", "48px"), (0,polished_esm/* borderRadius */.E0)("right", "48px"), (0,polished_esm/* borderWidth */.J4)("1px"), (0,polished_esm/* borderStyle */.$u)("solid"), (0,polished_esm/* borderColor */.tv)(border)), {
                    ":active": {
                        backgroundColor: backgroundColor
                    },
                    ":hover": (0,_object_spread/* default */.Z)({
                        color: hoverColor,
                        backgroundColor: hoverBackgroundColor
                    }, (0,polished_esm/* borderColor */.tv)(hoverBorder)),
                    ":disabled": (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        color: disabledColor,
                        backgroundColor: disabledBackgroundColor
                    }, (0,polished_esm/* borderColor */.tv)("transparent")), {
                        ":hover": (0,_object_spread/* default */.Z)({
                            color: disabledColor,
                            backgroundColor: disabledBackgroundColor
                        }, (0,polished_esm/* borderColor */.tv)("transparent"))
                    })
                })
            },
            StartEnhancer: {
                style: {
                    marginRight: "4px"
                }
            },
            EndEnhancer: {
                style: {
                    marginLeft: "4px"
                }
            },
            LoadingSpinnerContainer: {
                style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,polished_esm/* margin */.e6)("0px")), {
                    height: size.lineHeight,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                })
            }
        }, overrides),
        startEnhancer: leading && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* Icon */.J, {
            type: leading,
            size: $size === "l" ? 16 : 12,
            color: props.disabled ? disabledColor : color
        }),
        endEnhancer: trailing && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* Icon */.J, {
            type: trailing,
            size: $size === "l" ? 16 : 12,
            color: props.disabled ? disabledColor : color
        })
    }, props), {
        ref: ref,
        children: children
    }));
});


/***/ }),

/***/ 22974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TextButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var baseui_button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53674);
/* harmony import */ var _hooks_use_overrides__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(58817);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43281);
/* harmony import */ var _icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(32079);
/* harmony import */ var _styles_typography__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67246);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32317);
/* harmony import */ var _hooks_use_space__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16333);












var TextButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var children = _param.children, overrides = _param.overrides, leading = _param.leading, trailing = _param.trailing, spaceTop = _param.spaceTop, spaceBottom = _param.spaceBottom, _color = _param.color, color = _color === void 0 ? _styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray600 */ .O.gray600 : _color, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "overrides",
        "leading",
        "trailing",
        "spaceTop",
        "spaceBottom",
        "color"
    ]);
    var disabledColor = _styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray300 */ .O.gray300;
    var backgroundColor = "transparent";
    var _$ref = (0,_hooks_use_space__WEBPACK_IMPORTED_MODULE_4__/* .useSpace */ .$)({
        spaceTop: spaceTop,
        spaceBottom: spaceBottom
    }), marginTop = _$ref.marginTop, marginBottom = _$ref.marginBottom;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        overrides: (0,_hooks_use_overrides__WEBPACK_IMPORTED_MODULE_8__/* .useOverrides */ .Q)({
            BaseButton: {
                style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                    color: color,
                    backgroundColor: backgroundColor
                }, marginTop, marginBottom, _styles_typography__WEBPACK_IMPORTED_MODULE_9__/* .typography.LabelS */ .c.LabelS), {
                    boxSizing: "border-box",
                    fontWeight: 400,
                    display: "inline-flex",
                    alignSelf: "center",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    userSelect: "none",
                    whiteSpace: "pre"
                }), (0,polished__WEBPACK_IMPORTED_MODULE_10__/* .padding */ .o3)("0px")), {
                    ":active": {
                        backgroundColor: backgroundColor
                    },
                    ":hover": {
                        color: color,
                        backgroundColor: backgroundColor
                    },
                    ":disabled": {
                        color: disabledColor,
                        backgroundColor: backgroundColor,
                        ":hover": {
                            textShadow: "none",
                            color: disabledColor,
                            backgroundColor: backgroundColor
                        }
                    },
                    ":after": {
                        content: '""',
                        position: "absolute",
                        bottom: "-1px",
                        left: trailing && "0px",
                        right: leading && "0px",
                        width: leading || trailing ? "calc(100% - 16px)" : "100%",
                        height: "1px",
                        backgroundColor: color
                    }
                })
            },
            StartEnhancer: {
                style: {
                    marginRight: "4px"
                }
            },
            EndEnhancer: {
                style: {
                    marginLeft: "4px"
                }
            }
        }, overrides),
        startEnhancer: leading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon__WEBPACK_IMPORTED_MODULE_11__/* .Icon */ .J, {
            type: leading,
            color: props.disabled ? disabledColor : color,
            size: 12
        }),
        endEnhancer: trailing && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon__WEBPACK_IMPORTED_MODULE_11__/* .Icon */ .J, {
            type: trailing,
            color: props.disabled ? disabledColor : color,
            size: 12
        })
    }, props), {
        ref: ref,
        children: children
    }));
});


/***/ }),

/***/ 47630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ tabOverrides; },
/* harmony export */   "N": function() { return /* binding */ BaseTab; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_use_overrides__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(58817);
/* harmony import */ var baseui_tabs_motion__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67163);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43281);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32317);
/* harmony import */ var _styles_typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67246);









var tabOverrides = {
    Tab: {
        style: function(param) {
            var $isActive = param.$isActive;
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                fontWeight: 700,
                color: $isActive ? _styles_colors__WEBPACK_IMPORTED_MODULE_3__/* .colors.gray700 */ .O.gray700 : _styles_colors__WEBPACK_IMPORTED_MODULE_3__/* .colors.gray400 */ .O.gray400
            }, (0,polished__WEBPACK_IMPORTED_MODULE_4__/* .padding */ .o3)("8px", "16px"), (0,polished__WEBPACK_IMPORTED_MODULE_4__/* .margin */ .e6)("0px"), _styles_typography__WEBPACK_IMPORTED_MODULE_5__/* .typography.LabelL */ .c.LabelL), {
                whiteSpace: "pre",
                ":hover": {
                    background: _styles_colors__WEBPACK_IMPORTED_MODULE_3__/* .colors.gray50 */ .O.gray50
                }
            });
        }
    },
    TabPanel: {
        style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, (0,polished__WEBPACK_IMPORTED_MODULE_4__/* .padding */ .o3)("16px", "0px")), {
            color: _styles_colors__WEBPACK_IMPORTED_MODULE_3__/* .colors.gray700 */ .O.gray700
        })
    }
};
var BaseTab = function(_param) {
    var children = _param.children, overrides = _param.overrides, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "children",
        "overrides"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_tabs_motion__WEBPACK_IMPORTED_MODULE_7__/* .Tab */ .O, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        overrides: (0,_hooks_use_overrides__WEBPACK_IMPORTED_MODULE_8__/* .useOverrides */ .Q)(tabOverrides, overrides)
    }, props), {
        children: children
    }));
};


/***/ }),

/***/ 70952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ BaseTabs; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_use_overrides__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58817);
/* harmony import */ var baseui_tabs_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78557);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43281);







var BaseTabs = function(_param) {
    var children = _param.children, overrides = _param.overrides, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "overrides"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_tabs_motion__WEBPACK_IMPORTED_MODULE_2__/* .Tabs */ .m, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        overrides: (0,_hooks_use_overrides__WEBPACK_IMPORTED_MODULE_5__/* .useOverrides */ .Q)({
            TabBorder: {
                style: {
                    height: "1px"
                }
            },
            TabHighlight: {
                style: {
                    height: "1px"
                }
            },
            TabList: {
                style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, (0,polished__WEBPACK_IMPORTED_MODULE_6__/* .padding */ .o3)("0px"), (0,polished__WEBPACK_IMPORTED_MODULE_6__/* .margin */ .e6)("0px"))
            }
        }, overrides)
    }, props), {
        children: children
    }));
};


/***/ }),

/***/ 26022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ InfoBoxWithIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32317);
/* harmony import */ var _styles_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45500);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43281);
/* harmony import */ var styletron_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54511);
/* harmony import */ var _base_block__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94306);
/* harmony import */ var _icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32079);










var InfoBoxWithIcon = function(param) {
    var children = param.children, icon = param.icon;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,styletron_react__WEBPACK_IMPORTED_MODULE_2__/* .useStyletron */ .hQ)(), 1), css = ref[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_base_block__WEBPACK_IMPORTED_MODULE_3__/* .BaseBlock */ .v, {
        className: css((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            width: "100%"
        }, (0,polished__WEBPACK_IMPORTED_MODULE_6__/* .padding */ .o3)("20px"), (0,_styles_utils__WEBPACK_IMPORTED_MODULE_7__/* .borderRadius */ .E0)(16), (0,_styles_utils__WEBPACK_IMPORTED_MODULE_7__/* .border */ .Cg)(_styles_colors__WEBPACK_IMPORTED_MODULE_8__/* .colors.gray200 */ .O.gray200)), {
            display: "flex",
            flexDirection: "column",
            boxSizing: "border-box"
        })),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon__WEBPACK_IMPORTED_MODULE_9__/* .Icon */ .J, {
                type: icon,
                size: 32,
                color: _styles_colors__WEBPACK_IMPORTED_MODULE_8__/* .colors.gray700 */ .O.gray700
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_block__WEBPACK_IMPORTED_MODULE_3__/* .BaseBlock */ .v, {
                marginTop: "12px",
                children: children
            })
        ]
    });
};


/***/ }),

/***/ 99407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ BasicLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var src_sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(82492);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: ./node_modules/styletron-react/dist-browser-esm/index.js
var dist_browser_esm = __webpack_require__(54511);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./styles/constants.ts
var constants = __webpack_require__(45875);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./styles/colors.ts
var styles_colors = __webpack_require__(32317);
// EXTERNAL MODULE: ./components/base-button/base-button.tsx + 1 modules
var base_button = __webpack_require__(11485);
// EXTERNAL MODULE: ./modules/users/hooks/use-me.tsx
var use_me = __webpack_require__(17243);
// EXTERNAL MODULE: ./node_modules/baseui/esm/flex-grid/flex-grid.js + 1 modules
var flex_grid = __webpack_require__(46322);
// EXTERNAL MODULE: ./node_modules/baseui/esm/flex-grid/flex-grid-item.js
var flex_grid_item = __webpack_require__(11524);
// EXTERNAL MODULE: ./components/logo/logo.tsx + 1 modules
var logo = __webpack_require__(49965);
// EXTERNAL MODULE: ./components/header/header-menu.tsx
var header_menu = __webpack_require__(97006);
// EXTERNAL MODULE: ./styles/box-shadow.ts
var box_shadow = __webpack_require__(24035);
// EXTERNAL MODULE: ./components/base-grid/base-grid.tsx
var base_grid = __webpack_require__(83825);
// EXTERNAL MODULE: ./components/base-cell/base-cell.tsx
var base_cell = __webpack_require__(84525);
// EXTERNAL MODULE: ./styles/z-indexes.ts
var z_indexes = __webpack_require__(9227);
// EXTERNAL MODULE: ./lib/routes.ts
var routes = __webpack_require__(78954);
// EXTERNAL MODULE: ./lib/hooks/use-scroll-point.tsx
var use_scroll_point = __webpack_require__(51774);
// EXTERNAL MODULE: ./components/base-block/base-block.tsx
var base_block = __webpack_require__(94306);
// EXTERNAL MODULE: ./components/header/drawer.tsx
var drawer = __webpack_require__(95587);
// EXTERNAL MODULE: ./lib/graphql/documents.generated.ts
var documents_generated = __webpack_require__(60369);
;// CONCATENATED MODULE: ./components/header/header.tsx
























var Header = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref = (0,src_sliced_to_array/* default */.Z)((0,dist_browser_esm/* useStyletron */.hQ)(), 1), css = ref[0];
    var ref1 = (0,use_me/* useMe */.P)(), me = ref1.me, loading = ref1.loading;
    var isLoggedIn = Boolean(me);
    var isPoint = (0,use_scroll_point/* useScrollPoint */.A)().isPoint;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: css((0,_object_spread/* default */.Z)({
            position: "fixed",
            top: 0,
            width: "100%",
            boxSizing: "border-box",
            backgroundColor: styles_colors/* colors.white */.O.white,
            zIndex: z_indexes/* zIndexes.header */.U.header
        }, isPoint && (0,box_shadow/* boxShadow */.W)("borderBottom"))),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_grid/* BaseGrid */.w, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_cell/* BaseCell */.q, {
                span: [
                    4,
                    8,
                    12
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex_grid/* default */.Z, {
                    className: css({
                        height: constants/* HEADER_HEIGHT */.M + "px",
                        display: "flex",
                        alignItems: "center"
                    }),
                    gridColumnGap: "32px",
                    flexGridColumnCount: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(flex_grid_item/* default */.ZP, {
                            className: css({
                                flex: "1 1 0"
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* Logo */.T, {
                                size: "s",
                                active: true
                            })
                        }, "logo"),
                        !loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(flex_grid_item/* default */.ZP, {
                                    display: [
                                        "none",
                                        "none",
                                        "block",
                                        "block"
                                    ],
                                    className: css({
                                        flex: "1 1 auto"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(flex_grid_item/* default */.ZP, {
                                    className: css({
                                        flex: "1 1 0",
                                        display: "flex",
                                        justifyContent: "flex-end"
                                    }),
                                    children: !loading && isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(drawer/* BaseDrawer */.L, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_menu/* HeaderMenu */.y, {
                                                menus: (0,_to_consumable_array/* default */.Z)(me && (me === null || me === void 0 ? void 0 : me.role) !== documents_generated/* UserRole.Patient */.i4.Patient && [
                                                    {
                                                        name: "해석 참여하기",
                                                        icon: "ChevronRight",
                                                        href: routes/* Routes.DOCTOR_HOME */.Z.DOCTOR_HOME,
                                                        onClick: undefined,
                                                        color: undefined
                                                    }, 
                                                ] || []).concat([
                                                    {
                                                        name: "설정",
                                                        icon: undefined,
                                                        href: routes/* Routes.SETTINGS_ACCOUNT */.Z.SETTINGS_ACCOUNT,
                                                        onClick: undefined,
                                                        color: undefined
                                                    }, 
                                                ])
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_block/* BaseBlock */.v, {
                                        flexbox: true,
                                        columnGap: "16px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: routes/* Routes.AUTH_LOGIN */.Z.AUTH_LOGIN,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_button/* BaseButton */.Y, {
                                                    $type: "secondary",
                                                    $size: "m",
                                                    children: "로그인"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: routes/* Routes.AUTH_LOGIN */.Z.AUTH_LOGIN,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_button/* BaseButton */.Y, {
                                                    $size: "m",
                                                    children: "회원가입"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var NavItem = function(param) {
    var href = param.href, label = param.label, selected = param.selected;
    var ref = _sliced_to_array(useStyletron(), 1), css = ref[0];
    return /*#__PURE__*/ _jsx(Link, {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ _jsx(LabelS, {
            as: "a",
            weight: 500,
            color: selected ? colors.black : colors.gray500,
            children: label
        })
    });
};

// EXTERNAL MODULE: ./components/footer/footer.tsx + 2 modules
var footer = __webpack_require__(5516);
;// CONCATENATED MODULE: ./components/layouts/basic-layout.tsx








var BasicLayout = function(param) {
    var children = param.children, overrides = param.overrides, helmetTitle = param.helmetTitle;
    var ref;
    var ref1 = (0,src_sliced_to_array/* default */.Z)((0,dist_browser_esm/* useStyletron */.hQ)(), 1), css = ref1[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            helmetTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: helmetTitle
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: css({
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "100vh",
                    overflow: "hidden"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: css(merge_default()({
                            flex: "1 1 auto",
                            overflowY: "hidden",
                            overflowX: "hidden",
                            position: "relative",
                            marginTop: constants/* HEADER_HEIGHT */.M + "px"
                        }, (overrides === null || overrides === void 0 ? void 0 : (ref = overrides.main) === null || ref === void 0 ? void 0 : ref.style) || {})),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: children
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* Footer */.$, {})
                ]
            })
        ]
    });
};


/***/ }),

/***/ 90638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(96856)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadable = _interop_require_default(__webpack_require__(14302));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 16319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(79658)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(7222)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadableContext = __webpack_require__(16319);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(61688)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 39331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6812);
/* harmony import */ var _components_layouts_basic_layout__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(99407);
/* harmony import */ var _components_base_accordion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1650);
/* harmony import */ var _components_base_accordion__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(80635);
/* harmony import */ var _components_base_block__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94306);
/* harmony import */ var _components_base_button__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(22974);
/* harmony import */ var _components_base_cell__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84525);
/* harmony import */ var _components_base_grid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83825);
/* harmony import */ var _components_base_tabs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70952);
/* harmony import */ var _components_base_tabs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47630);
/* harmony import */ var _components_base_typography__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53321);
/* harmony import */ var _components_base_typography__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(67408);
/* harmony import */ var _components_info_box_with_icon__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26022);
/* harmony import */ var _lib_graphql_documents_generated__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60369);
/* harmony import */ var _lib_routes__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(78954);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(32317);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);


















var EditorViewer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6910), __webpack_require__.e(8562), __webpack_require__.e(6911), __webpack_require__.e(3726), __webpack_require__.e(5731), __webpack_require__.e(505)]).then(__webpack_require__.bind(__webpack_require__, 90505));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90505)
            ];
        }
    },
    ssr: false
});
var FaqPage = function() {
    var ref = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_lib_graphql_documents_generated__WEBPACK_IMPORTED_MODULE_5__/* .GetAllFaqCategoriesDocument */ .Om), data = ref.data, loading = ref.loading;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(1), activeKey = ref1[0], setActiveKey = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(), currentList = ref2[0], setCurrentList = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (loading || !(data === null || data === void 0 ? void 0 : data.allFaqs) || data.allFaqs.length === 0) return;
        setCurrentList(data.allFaqs[0].faqs || []);
    }, [
        data === null || data === void 0 ? void 0 : data.allFaqs,
        loading
    ]);
    var accordions = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return currentList === null || currentList === void 0 ? void 0 : currentList.map(function(param) {
            var id = param.id, title = param.title, description = param.description;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_accordion__WEBPACK_IMPORTED_MODULE_6__/* .BasePanel */ .f, {
                title: title,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EditorViewer, {
                    initialValue: description || ""
                })
            }, id);
        });
    }, [
        currentList
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_grid__WEBPACK_IMPORTED_MODULE_7__/* .BaseGrid */ .w, {
                spaceTop: [
                    24,
                    48,
                    72
                ],
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_cell__WEBPACK_IMPORTED_MODULE_8__/* .BaseCell */ .q, {
                        span: [
                            4,
                            6,
                            8
                        ],
                        skip: [
                            0,
                            1,
                            0
                        ],
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_typography__WEBPACK_IMPORTED_MODULE_9__/* .HeadingM */ .aw, {
                                children: "자주 묻는 질문"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_block__WEBPACK_IMPORTED_MODULE_10__/* .BaseBlock */ .v, {
                                marginTop: "40px",
                                marginBottom: "40px",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_tabs__WEBPACK_IMPORTED_MODULE_11__/* .BaseTabs */ .A, {
                                    activeKey: activeKey,
                                    onChange: function(param) {
                                        var activeKey = param.activeKey;
                                        var current = data === null || data === void 0 ? void 0 : data.allFaqs.find(function(faq) {
                                            return faq.id === Number(activeKey);
                                        });
                                        if (current === null || current === void 0 ? void 0 : current.faqs) {
                                            setCurrentList(current.faqs);
                                        }
                                        setActiveKey(activeKey);
                                    },
                                    activateOnFocus: true,
                                    children: !loading && (data === null || data === void 0 ? void 0 : data.allFaqs.map(function(param) {
                                        var id = param.id, name = param.name;
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_tabs__WEBPACK_IMPORTED_MODULE_12__/* .BaseTab */ .N, {
                                            title: name,
                                            overrides: _components_base_tabs__WEBPACK_IMPORTED_MODULE_12__/* .tabOverrides */ .F,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_accordion__WEBPACK_IMPORTED_MODULE_13__/* .BaseAccordion */ .S, {
                                                stateReducer: function(_, nextState) {
                                                    return nextState;
                                                },
                                                children: accordions
                                            })
                                        }, id);
                                    }))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_cell__WEBPACK_IMPORTED_MODULE_8__/* .BaseCell */ .q, {
                        span: [
                            4,
                            3,
                            3
                        ],
                        skip: [
                            0,
                            1,
                            1
                        ],
                        spaceTop: [
                            72,
                            72,
                            72
                        ],
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_info_box_with_icon__WEBPACK_IMPORTED_MODULE_14__/* .InfoBoxWithIcon */ .R, {
                            icon: "Headset",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_typography__WEBPACK_IMPORTED_MODULE_15__/* .LabelM */ .i_, {
                                    whiteSpace: "pre-wrap",
                                    children: "문제가 해결되지 않았다면\n1대1 문의로 질문해주세요."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: _lib_routes__WEBPACK_IMPORTED_MODULE_16__/* .Routes.SUPPORT_INQUIRY_WRITE */ .Z.SUPPORT_INQUIRY_WRITE,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_button__WEBPACK_IMPORTED_MODULE_17__/* .TextButton */ .A, {
                                        spaceTop: 20,
                                        trailing: "ChevronRight",
                                        color: _styles_colors__WEBPACK_IMPORTED_MODULE_18__/* .colors.blue400 */ .O.blue400,
                                        children: "문의하기"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EditorViewer, {
                initialValue: ""
            })
        ]
    });
};
FaqPage.getLayout = function(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layouts_basic_layout__WEBPACK_IMPORTED_MODULE_19__/* .BasicLayout */ .i, {
        helmetTitle: "Ontol | 자주묻는질문",
        children: page
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FaqPage);


/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90638)


/***/ }),

/***/ 53250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(67294);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 61688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(53250);
} else {}


/***/ }),

/***/ 51351:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _throw; }
/* harmony export */ });
function _throw(e) {
    throw e;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7730,8116,4888,290,4627,3674,921,2227,8843,2079,1319,8639,9774,2888,179], function() { return __webpack_exec__(23580); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);